module.exports = __webpack_public_path__ + "img/back_02.28a2f335.png";